module.exports = __webpack_public_path__ + "9c7dad13b04ab7672b8b086b0944d458.svg";